import React from 'react';
import styled from 'styled-components';
import images from 'rc-images';

const Container = styled.button`
  padding: 0 !important;
  padding-top: 110px !important;
  float: left;
  cursor: pointer;
  position: relative;
  margin-bottom: 25px;
  border: none !important;
  background-color: transparent !important;
  

  &:hover{
    b {
      color: #404040 !important;
    }
  }

  @media (min-width: 940px) {
    width: 25%;
  }

  @media (min-width: 942px) and (max-width: 941px) {
    width: 33%;
  }

  @media (min-width: 820px) and (max-width: 941px) {
    width: 33%;
  }
  
  @media (min-width: 481px) and (max-width: 820px) {
    width: 33%;
  }
  
  @media (min-width: 400px) and (max-width: 480px) {
    width: 50%;
  }

  @media (min-width: 350px) and (max-width: 399px) {
    width: 50%;
  }

  @media (min-width: 320px) and (max-width: 349px) {
    width: 50%;
  }

  @media (max-width: 319px) {
    width: 100%;
  }
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none !important;
  }

  &:before {
    content: '';
    position: absolute;
    background-image: url(${images.materialGroupImages});
    left: 50%;
    top: 50%;
    width: 100px;
    height: 100px;
    transform: translate(-50%, -60%) scale(0.8);
  }
`;

const Title = styled.b`
  all: initial;
  color: #666;
  text-transform: uppercase;
  font-size: 11px !important;
  text-align: center;
  line-height: 2em !important;
  letter-spacing: 1px;
  display: block;
  font-weight: normal !important;
`;

const GroupItem = ({ item, onClick }) => {
  const {
    title, icon, id
  } = item;

  const clickHandler = () => {
    onClick(id);
  };

  return (
    <Container
      aria-label={title}
      tabIndex="0"
      className={`wgw-group-item ${icon}`}
      onClick={clickHandler}
    >
      <Title tabIndex="-1">
        {title}
      </Title>
    </Container>
  );
};

export default GroupItem;
